export default __webpack_public_path__ + "static/media/ico_file.b39f4b82.svg";